module.exports = "/lucky-balls/img/jackpot/019.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/jackpot/019.png
// module id = 1119
// module chunks = 0